module.exports = __webpack_public_path__ + "img/table.e06fca96.svg";